import request from '@/utils/request'

// Apple store notification reconciliation. Admin only.
// Backend: POST /api/v2/admin/apple-notifications/audit
// (request baseURL already includes /api/v2).

export interface AppleNotificationAuditItem {
  notificationUUID: string | null
  notificationType: string | null
  subtype: string | null
  originalTransactionId: string | null
  productId: string | null
  signedDate: string | null
  // What Apple got back from us the first time it tried to deliver this.
  firstSendAttemptResult?: string
  // Whether we have a record of having handled it.
  processed: boolean
  replay?: {
    attempted: boolean
    status?: number
    // replayed | no_action_needed | handler_error | failed
    outcome?: string
    reason?: string
  }
}

export interface AppleNotificationAuditResult {
  environment: 'Production' | 'Sandbox'
  window: { startDate: string, endDate: string, hours: number }
  summary: {
    fromApple: number
    processed: number
    missing: number
    replayed: number
    replayRequested: boolean
  }
  items: AppleNotificationAuditItem[]
}

export interface AppleNotificationAuditParams {
  // No environment: the server decides which one it can audit, because App
  // Store Connect delivers each environment's notifications only to the server
  // configured for it. The answer reports which was used.
  hours?: number
  // Leave replay off to get a report only; the backend does nothing until it is
  // explicitly asked to.
  replay?: boolean
  limit?: number
}

export const auditAppleNotifications = (params: AppleNotificationAuditParams) =>
  request({ url: '/admin/apple-notifications/audit', method: 'post', data: params })
